import React, { useState } from 'react';
import { PlusIcon, XIcon } from 'lucide-react';
interface ColorPickerProps {
  colors: Array<{
    hex: string;
    name: string;
  }>;
  onChange: (colors: Array<{
    hex: string;
    name: string;
  }>) => void;
  label?: string;
}
// Simple helper to guess color name based on hex
const guessColorName = (hex: string) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  if (r > 200 && g < 100 && b < 100) return 'Rood';
  if (r < 100 && g > 200 && b < 100) return 'Groen';
  if (r < 100 && g < 100 && b > 200) return 'Blauw';
  if (r > 200 && g > 200 && b < 100) return 'Geel';
  if (r > 200 && g > 100 && b < 100) return 'Oranje';
  if (r > 200 && g < 100 && b > 200) return 'Paars';
  if (r < 50 && g < 50 && b < 50) return 'Zwart';
  if (r > 240 && g > 240 && b > 240) return 'Wit';
  if (r > 100 && r < 200 && g > 100 && g < 200 && b > 100 && b < 200) return 'Grijs';
  return 'Kleur';
};
export function ColorPicker({
  colors,
  onChange,
  label = 'Kies uw merkkleuren'
}: ColorPickerProps) {
  const [currentColor, setCurrentColor] = useState('#007AFF');
  const addColor = () => {
    if (colors.length >= 10) return;
    const name = guessColorName(currentColor);
    onChange([...colors, {
      hex: currentColor,
      name
    }]);
  };
  const removeColor = (index: number) => {
    const newColors = [...colors];
    newColors.splice(index, 1);
    onChange(newColors);
  };
  const updateColorName = (index: number, newName: string) => {
    const newColors = [...colors];
    newColors[index].name = newName;
    onChange(newColors);
  };
  return <div className="w-full" data-id="element-675" data-mp="ikercpb2k0jd">
      <label className="block text-sm font-semibold text-gray-900 mb-3" data-id="element-676" data-mp="ijltkdu38ldd">
        {label}
      </label>

      <div className="flex flex-col gap-3 mb-4" data-id="element-677" data-mp="2yarh0axfi36b">
        {colors.map((color, index) => <div key={index} className="flex items-center bg-white border border-gray-200 rounded-xl p-2 shadow-sm" data-id="element-678" data-mp="33bxd8iqas8kl" data-mpi={index}>
            <div className="w-8 h-8 rounded-full border border-gray-200 mr-3 flex-shrink-0" style={{
          backgroundColor: color.hex
        }} data-id="element-679" data-mp="2jam1zfbud76q" />
            <div className="flex-1 flex items-center gap-3" data-id="element-680" data-mp="2ae4pa7ntx18v">
              <input type="text" value={color.name} onChange={e => updateColorName(index, e.target.value)} placeholder="Naam (bijv. Primair, Tekst)" className="text-sm font-medium text-gray-900 border-b border-transparent hover:border-gray-300 focus:border-[#007AFF] focus:outline-none bg-transparent py-1 w-full max-w-[200px]" data-id="element-681" data-mp="25gv2kzrtr3oq" />
              <span className="text-xs text-gray-500 font-mono uppercase" data-id="element-682" data-mp="1mklinvu8riwt">
                {color.hex}
              </span>
            </div>
            <button onClick={() => removeColor(index)} className="p-2 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-full transition-colors ml-2 flex-shrink-0" data-id="element-683" data-mp="3gw0440g7yw6r">
              <XIcon className="w-4 h-4" data-id="element-684" data-mp="3te3xgyyfiphi" />
            </button>
          </div>)}
      </div>

      {colors.length < 10 && <div className="flex items-center space-x-4 bg-gray-50 p-4 rounded-xl border border-gray-200" data-id="element-685" data-mp="219izj8yoe60">
          <div className="relative w-12 h-12 rounded-full overflow-hidden border-2 border-white shadow-md flex-shrink-0" data-id="element-686" data-mp="71nigcwhyfsf">
            <input type="color" value={currentColor} onChange={e => setCurrentColor(e.target.value)} className="absolute -top-2 -left-2 w-16 h-16 cursor-pointer" data-id="element-687" data-mp="3ag9ub1jzf871" />
          </div>
          <div className="flex-1" data-id="element-688" data-mp="3jhr4626sqdna">
            <p className="text-sm font-medium text-gray-900" data-id="element-689" data-mp="3jemu4o6ngnop">Kies een kleur</p>
            <p className="text-xs text-gray-500 font-mono uppercase" data-id="element-690" data-mp="uovoix1r1svi">
              {currentColor}
            </p>
          </div>
          <button onClick={addColor} className="flex items-center px-4 py-2 bg-white border border-gray-200 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 hover:text-[#007AFF] hover:border-[#007AFF] transition-colors shadow-sm" data-id="element-691" data-mp="x9lbypvnwfs7">
            <PlusIcon className="w-4 h-4 mr-1" data-id="element-692" data-mp="175oc5q6ye4ci" />
            Toevoegen
          </button>
        </div>}
      <p className="text-xs text-gray-500 mt-2" data-id="element-693" data-mp="12b0uaa6gg86w">
        Voeg tot 10 kleuren toe (optioneel)
      </p>
    </div>;
}